import { faCalendarAlt, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { Alert, Modal } from "react-bootstrap";
import { getCurrentDuration, getCurrentDurationName, getDurationList, setDialog } from "../../store/api/CommonFunctions";
import BihatmaTable from "../BihamtaTable";
import { Calendar2Check, ExclamationCircle } from "react-bootstrap-icons";
import { useDispatch } from "react-redux";

const ModalDuration = (props) => {
    const dispatch = useDispatch();
    const [changeResult, setChangeResult] = useState(null);
    const [currDuration, setCurrDuration] = useState(null);
    const { popData, setPopData } = props;
    const [list, setList] = useState({ Data: [] });
    const { show } = popData;
    function close() {
        setChangeResult(null);
        setPopData({
            show: false
        })
    }
    function changeCurrentDuration(duration) {
        return () => {
            // const onSuccess = (res) => {
            //     if (res.Error) {
            //         setErrorDialog(dispatch, res.Error, "تغییر دوره مالی");
            //     }
            //     if (res !== "PENDING") {
            //         setErrorDialog(dispatch, "success", "تغییر دوره مالی");
            //         localStorage.setItem("DurationID", duration.DurationId);
            //         localStorage.setItem("DurationName", )
            //         setCurrDuration({ Data: duration.DurationName });
            //     }
            // }
            // changeDuration(duration.DurationId, onSuccess);            
            localStorage.setItem("DurationID", duration.DurationId);
            localStorage.setItem("DurationName", duration.DurationName);
            setChangeResult("صفحه را یکبار رفرش کنید", "تغییر دوره مالی");
            setCurrDuration(duration.DurationName);

        }
    }
    const tableCols = [
        { colTitle: "نام دوره", colName: "DurationName" },
        { colTitle: "تاریخ شروع دوره", colName: "PDurationStartDate" },
        { colTitle: "تاریخ پایان دوره", colName: "PDurationEndDate" }
    ]
    const tableRowButtons = [
        {
            type: "common", tooltip: "تغییر دوره مالی", icon: <Calendar2Check size={15} className="rowBtn" color="#5b23b5" />, onclick: (item) => {
                dispatch(setDialog({
                    status: 'show',
                    arrayBtn: ['yes', 'no'],
                    dialogTitle: 'تغییر دوره مالی',
                    dialogText: 'آیا از تغییر دوره مالی مطمئن هستید؟',
                    okOperation: changeCurrentDuration(item)
                }))
            }
        }
    ]
    useEffect(() => {
        if (show) {
            getDurationList(setList);
            const dName = getCurrentDurationName();
            if (dName === "") {
                const onSuccess = (res) => {
                    if (res.Data) {
                        //از آنجایی که شناسه دوره مالی برای تشخیص تغییر دوره به سمت سرور فرستاده می شود؛
                        // این شناسه را تنها در صورتی ذخیره میکنیم که قصد تغییر دوره مالی را داشته باشیم
                        localStorage.setItem("DurationName", res.Data.DurationName);
                        setCurrDuration(res.Data.DurationName);
                    }
                }
                getCurrentDuration(onSuccess);
            }
            else {
                setCurrDuration(dName.replace("دوره مالی فعال:", ""));
            }
        }
    }, [show])
    return (
        <Modal show={show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>
                    <FontAwesomeIcon icon={faCalendarAlt} size="lg" />&nbsp;
                    دوره های مالی
                </span>
                <FontAwesomeIcon icon={faTimes} size="lg" onClick={close} />
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                {changeResult && <Alert variant="warning"><ExclamationCircle size={18} />&nbsp; {changeResult}</Alert>}
                <BihatmaTable columns={tableCols} dataList={list} rowButtons={tableRowButtons} />
                {currDuration &&
                    <div style={{ padding: "6px", borderRadius: "3px", background: "linear-gradient(-45deg, #4b6ddb, transparent)", color: "whitesmoke" }}>
                        دوره مالی فعال:   {currDuration}
                    </div>
                }
            </Modal.Body>
        </Modal>
    )
}
export default ModalDuration;